import { Box, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ViewToggleButtonGroup } from "../../../components";
import { useBreakpoints } from "../../../hooks";
import { UserIssuesList, UserTaskItemsList } from "../../UserPages/UserImplementationPage/components";
import { useUserImplementationSettings } from "../../UserPages/UserImplementationPage/hooks";

interface Props {
  userGuid: string;
}

const UserImplementationReview = (props: Props) => {
  const { isMdUp } = useBreakpoints();
  const { settings, updateSettings } = useUserImplementationSettings(props.userGuid);
  const [isTableView, setIsTableView] = useState(true);

  useEffect(() => {
    handleViewToggled(settings.tableView);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userGuid]);

  useEffect(() => {
    if (isMdUp) {
      setIsTableView(settings.tableView);
    } else {
      setIsTableView(false);
    }
  }, [isMdUp, props.userGuid, settings]);

  function handleViewToggled(value: boolean) {
    setIsTableView(value);
    updateSettings({
      tableView: value,
    });
  }

  return (
    <Stack spacing={1}>
      <Card>
        <CardContent>
          <Stack direction="row" spacing={1} sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Stack spacing={0.25}>
              <Typography variant="h5">Implementation</Typography>
              <Typography>Tasks and Issues</Typography>
            </Stack>
            {isMdUp && <ViewToggleButtonGroup isTableView={isTableView} onViewToggled={handleViewToggled} />}
          </Stack>
        </CardContent>
      </Card>
      <Box>
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, lg: isTableView ? 12 : 8 }}>
            <UserTaskItemsList userGuid={props.userGuid} isTableView={isTableView} />
          </Grid>
          <Grid size={{ xs: 12, lg: isTableView ? 12 : 4 }}>
            <UserIssuesList userGuid={props.userGuid} isTableView={isTableView} />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
};

export { UserImplementationReview };
